import { ApiUser } from "./getUser"

export function getRedirectRoute(user: ApiUser) {
    let route = `${process.env.REACT_APP_ADVERTISER_PLATFORM_LANDING}`
    if (user.affiliate_user_id !== undefined) {
        route = `${process.env.REACT_APP_PUBLISHER_PLATFORM_LANDING}`
    }
    return route
}
